import React, { Component } from "react";

import { Translate, I18n } from "react-redux-i18n";

import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";

import { compressImage } from "../../utils/Utils";

import "../../../styles/components/chargers/modals/ActionInfrastructure.scss";
import camera from "../../../styles/images/camera.svg";
import station from "../../../styles/images/station.svg";

class EditInfrastructure extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;

    this.state = {
      validated: false,
      picture: station,
      name: "",
      cpe: "",
    };

    this.handlePickPicture = this.handlePickPicture.bind(this);
    this.handlePictureChange = this.handlePictureChange.bind(this);
    this.handleOnChange = this.handleOnChange.bind(this);
    this.handleOnSubmit = this.handleOnSubmit.bind(this);
    this.reset = this.reset.bind(this);
  }

  componentDidMount() {
    this._mounted = true;
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.selectedPlace)
      if (
        prevProps.selectedPlace !== this.props.selectedPlace ||
        prevProps.selectedPlace._id !== this.props.selectedPlace._id ||
        (this.props.selectedPlace.imageContent !== "" && this.state.picture === null)
      )
        this.safeSetState({
          picture: this.props.selectedPlace.imageContent + "?v=" + Date.now(),
          name: this.props.selectedPlace.name,
          cpe: this.props.selectedPlace.CPE ?? "",
        });
  }

  componentWillUnmount() {
    this._mounted = false;
  }

  handlePickPicture(e) {
    document.getElementById("file-picker").click();
  }

  handlePictureChange(e) {
    let file = e.target.files && e.target.files[0];

    compressImage(file).then(picture => {
      this.safeSetState({ picture });
    });
  }

  handleOnChange(e) {
    this.safeSetState({
      [e.target.name]: e.target.value,
    });
  }

  handleOnSubmit(e) {
    e.preventDefault();
    const form = e.target;
    this.safeSetState({ validated: true }, () => {
      if (form.checkValidity() !== false) {
        this.props.onSubmit(form.elements, this.state.picture);
      }
    });
  }

  reset() {
    this.safeSetState({
      validated: false,
      picture: null,
    });
  }

  safeSetState(params, callback) {
    if (this._mounted) this.setState(params, callback);
  }

  render() {
    return (
      <>
        <Modal
          id="editInfrastructure"
          show={this.props.show}
          onHide={this.props.onHide}
          onExited={this.reset}
          centered
        >
          <Modal.Header>
            <Modal.Title>
              <Translate value="myChargers_editChargerPlace" />
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="picture-picker-container">
              <input
                id="file-picker"
                type="file"
                accept="image/*"
                style={{ display: "none" }}
                onChange={this.handlePictureChange}
              />
              <button type="button" className="picture-picker" onClick={this.handlePickPicture}>
                <img id="picture" src={this.state.picture || station} alt="" />
                <img src={camera} className="camera" alt="" />
              </button>
            </div>
            <Form
              id="edit-infrastructure-form"
              noValidate
              validated={this.state.validated}
              onSubmit={this.handleOnSubmit}
            >
              <Form.Group className="form-field">
                <Form.Label>
                  <Translate value="myChargersAddInfr_name" />
                </Form.Label>
                <Form.Control
                  type="text"
                  name="name"
                  placeholder={I18n.t("myChargersAddInfr_exHome")}
                  value={this.state.name}
                  onChange={this.handleOnChange}
                  required
                />
                <Form.Control.Feedback type="invalid">
                  <Translate value="myChargersAddInfr_invalidInfrName" />
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group className="form-field">
                <Form.Label>
                  <Translate value="myChargersAddInfr_cpe" />
                </Form.Label>
                <Form.Control
                  type="text"
                  name="cpe"
                  value={this.state.cpe}
                  onChange={this.handleOnChange}
                />
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <button type="submit" form="edit-infrastructure-form">
              <Translate value="myChargers_editChargerPlace" />
            </button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}

export default EditInfrastructure;
